<!-- Check Eligibility form-->
<fieldset>
  <legend><span class="screen-reader-only">{{'TrainingEligibility.CourseEligibilityDetails' | translate }}</span></legend>
  <div [ngClass]="isSingleTeamMember ? 'eligibility-checker-div' : 'multi-member-div'">
    <!-- component header (title) -->
    <div class="header-row">
      <h3>
        {{'TrainingEligibility.CourseEligibilityDetails' | translate }}
      </h3>
      @if (!isSingleTeamMember) {
        <button [class.expanded]="eligCheckerExpanded" (click)="eligCheckerExpanded = !eligCheckerExpanded">
          @if (!eligCheckerExpanded) {
            <img alt="expand" src="assets/images/chevron-down-white-border-grey-background.svg">
          }
          @if (eligCheckerExpanded) {
            <img alt="collapse" src="assets/images/chevron-down-white-border-grey-background.svg">
          }
        </button>
      }
    </div>
    <!-- end header -->
    <!-- content -->
    @if (eligCheckerExpanded) {
      @if (!bannerType && eligibilityForm && courseDto) {
        <form [formGroup]="eligibilityForm">
          <div class="content">
            <div class="training-details">
              <div class="table-header">
                <div class="training-details-row">
                  <app-horizontal-radio-button-list [label]="'TrainingEligibility.EnterNameOrMls' | translate"
                    [currentLang]="currentLang" [radioButtonOptions]="identificationOptions"
                    (valueChange)="setIdentificationOption($event)" [(value)]="identificationOption">
                  </app-horizontal-radio-button-list>
                </div>
                <div class="training-details-row ontario-small-12 ontario-medium-5 ontario-large-5">
                  @if (identificationOption === 'id') {
                    <input type="text" class='input-text' matInput
                      formControlName="learnerID" [attr.aria-label]="currentLang === 'fr' ? 'ID d’apprenant' : 'Learner ID'" placeholder="{{'TrainingEligibility.LearnerIdTooltip' | translate}}" />
                  }
                  @if (identificationOption === 'name') {
                    <input autocomplete="name" type="text" class='input-text' matInput
                      formControlName="learnerName" [attr.aria-label]="currentLang === 'fr' ? 'Nom de l’apprenant' : 'Learner name'" placeholder="{{'TrainingEligibility.NameTooltip' | translate}}" />
                  }
                </div>
                @if (identificationOption === 'id' && eligibilityForm.controls['learnerID'].invalid &&  eligibilityForm.controls['learnerID'].errors &&
                  (eligibilityForm.controls['learnerID'].dirty || eligibilityForm.controls['learnerID'].touched)) {
                  <div role="alert">
                    @if (eligibilityForm.controls['learnerID'].hasError('maxlength')) {
                      <mat-error class="matErrorLearnerID">
                        {{'TrainingEligibility.Validation.LearnerID.MaxLength' | translate}}
                      </mat-error>
                    }
                    @if (eligibilityForm.controls['learnerID'].hasError('pattern')) {
                      <mat-error class="matErrorLearnerID">
                        {{'TrainingEligibility.Validation.LearnerID.Pattern' | translate}}
                      </mat-error>
                    }
                  </div>
                }
                @if (identificationOption === 'name' && eligibilityForm.controls['learnerName'].invalid &&  eligibilityForm.controls['learnerName'].errors &&
                  (eligibilityForm.controls['learnerName'].dirty || eligibilityForm.controls['learnerName'].touched)) {
                  <div role="alert">
                    @if (eligibilityForm.controls['learnerName'].hasError('maxlength')) {
                      <mat-error class="matErrorLearnerName">
                        {{'TrainingEligibility.Validation.LearnerName.MaxLength' | translate}}
                      </mat-error>
                    }
                  </div>
                }
                <div class="training-details-row margined-top">
                  <app-horizontal-radio-button-list [label]="'TrainingEligibility.EnterEmailPhonePostal' | translate"
                    [currentLang]="currentLang" [radioButtonOptions]="contactOptions"
                    (valueChange)="setContactOption($event)" [(value)]="contactOption">
                  </app-horizontal-radio-button-list>
                </div>
                <div class="training-details-row ontario-small-12 ontario-medium-5 ontario-large-5">
                  @if (contactOption === 'email') {
                    <input autocomplete="email"  type="email" class='input-text' matInput formControlName="emailID" [attr.aria-label]="currentLang === 'fr' ? 'Adresse courriel' : 'Email address'"
                      placeholder="{{'TrainingEligibility.EmailTooltip' | translate}}" />
                  }
                  @if (contactOption === 'phone') {
                    <input autocomplete="tel" type='tel' class='input-text' mask="000-000-0000" matInput formControlName="phoneNo" [attr.aria-label]="currentLang === 'fr' ? 'Numéro de téléphone' : 'Phone number'"
                      placeholder="{{'TrainingEligibility.PhoneTooltip' | translate}}" />
                  }
                  @if (contactOption === 'postal') {
                    <input autocomplete="postal-code" type="text" class='input-text' matInput formControlName="postalCode" [attr.aria-label]="currentLang === 'fr' ? 'Code postal' : 'Postal code'"
                      placeholder="{{'TrainingEligibility.PostalTooltip' | translate}}" />
                  }
                </div>
                @if (contactOption === 'email' && eligibilityForm.controls['emailID'].invalid &&  eligibilityForm.controls['emailID'].errors &&
                  (eligibilityForm.controls['emailID'].dirty || eligibilityForm.controls['emailID'].touched)) {
                  <div role="alert">
                    @if (eligibilityForm.controls['emailID'].hasError('pattern')) {
                      <mat-error class="matErrorEmail">
                        {{'Validation.Email.Pattern' | translate}}
                      </mat-error>
                    }
                  </div>
                }
                @if (contactOption === 'phone' && eligibilityForm.controls['phoneNo'].invalid &&  eligibilityForm.controls['phoneNo'].errors &&
                  (eligibilityForm.controls['phoneNo'].dirty || eligibilityForm.controls['phoneNo'].touched)) {
                  <div role="alert">
                    @if (eligibilityForm.controls['phoneNo'].hasError('pattern')) {
                      <mat-error class="matErrorPhone">
                        {{'Validation.Phone.Pattern' | translate}}
                      </mat-error>
                    }
                  </div>
                }
                @if (contactOption === 'postal' && eligibilityForm.controls['postalCode'].invalid &&  eligibilityForm.controls['postalCode'].errors &&
                  (eligibilityForm.controls['postalCode'].dirty || eligibilityForm.controls['postalCode'].touched)) {
                  <div role="alert">
                    @if (eligibilityForm.controls['postalCode'].hasError('pattern')) {
                      <mat-error class="matErrorPostal">
                        {{'Validation.PostalCode.Pattern' | translate}}
                      </mat-error>
                    }
                  </div>
                }
              </div>
              <div class="action-buttons-elig ontario-small-12 ontario-large-12 ontario-medium-12">
                <button class="black-button" (click)="checkIfEligible()" [disabled]="(eligibilityForm.controls['learnerID'].value == '' || eligibilityForm.controls['emailID'].value == '' )">
                  {{'TrainingEligibility.CheckEligibility' | translate}}
                </button>
                @if (currentLang == 'en' && courseDto.ProgramFullName.includes('JHSC')) {
                  <button class="link-button" (click)="linkButtonClicked('test.com')">
                    {{'LoginHeader.LearnMore' | translate}}<img alt="" src="assets/images/external-link-blue.svg">
                  </button>
                }
                @if (currentLang == 'en' && courseDto.ProgramFullName.includes('Working at Heights')) {
                  <button class="link-button" (click)="WAHlinkedButtonClicked('test.com')">
                    {{'LoginHeader.LearnMore' | translate}}<img alt="" src="assets/images/external-link-blue.svg">
                  </button>
                }
                @if (currentLang == 'fr' && courseDto.ProgramFullName.includes('JHSC')) {
                  <button class="link-button" (click)="linkedButtonClickedFr('test.com')">
                    {{'LoginHeader.LearnMore' | translate}}<img alt="" src="assets/images/external-link-blue.svg">
                  </button>
                }
                @if (currentLang == 'fr' && courseDto.ProgramFullName.includes('Working at Heights')) {
                  <button class="link-button" (click)="WAHlinkedButtonClickedFr('test.com')">
                    {{'LoginHeader.LearnMore' | translate}}<img alt="" src="assets/images/external-link-blue.svg">
                  </button>
                }
              </div>
            </div>
          </div>
        </form>
      }
      <!-- end Check Eligibility form-->
      <!-- Check Eligibility results -->
      @if (bannerType) {
        <div class="content ontario-small-12 ontario-large-12 ontario-medium-12">
          <div class="elig-results">
            <div>{{'TrainingEligibility.YourEligibility' | translate}}</div>
            <div class="banner">
              <div class="icon-div">
                <div class="banner-circle" [ngClass]="bannerType">
                  @if (bannerType == 'success') {
                    <img alt="checkmark" src="assets/images/checkmark-green.svg"
                      alt="alert">
                  }
                  @if (bannerType == 'failure') {
                    <img alt="failed" src="assets/images/fail-cross-red.svg" alt="alert">
                  }
                  @if (bannerType == 'userNotFound') {
                    <img alt="not found"  src="assets/images/not-found.svg" alt="alert">
                  }
                </div>
              </div>
              <div class="icon-text">
                @if (bannerType == 'success') {
                  <p
                    [innerHTML]='("TrainingEligibility.Results.EligibleForCourse" | translate).replace("{0}", currentLang == "en" ? courseDto.ProgramFullName : courseDto.ProgramFullNameFr)'>
                  </p>
                }
                @if (bannerType == 'failure') {
                  <p
                    [innerHTML]='("TrainingEligibility.Results.NotEligibleForCourse" | translate).replace("{0}", currentLang == "en" ? courseDto.ProgramFullName : courseDto.ProgramFullNameFr).replace("{1}", currentLang == "en" ? checkEligibility?.Link : checkEligibility?.LinkFr)'>
                  </p>
                }
                @if (bannerType == 'userNotFound') {
                  <p
                    [innerHTML]='("TrainingEligibility.Results.CouldNotFindRecords" | translate).replace("{0}", currentLang == "en" ? learnMoreUrlPlaceholder : learnMoreUrlPlaceholder)'>
                  </p>
                }
                @if (bannerType == 'success' || bannerType == 'failure') {
                  <app-checkbox
                    [name]="'TrainingEligibility.DoNotIncludeEligibility' | translate"
                    [checked]="!shareEligibilityResults"
                    (checkedChange)="shareEligibilityResultsChanged($event)">
                  </app-checkbox>
                }
              </div>
            </div>
            @if (bannerType == 'failure' || bannerType == 'userNotFound') {
              <div class="banner">
                <app-alert-banner bannerType="alert" [bannerText]="translateService.instant('TrainingEligibility.CourseEligibilityRequirement').replace('{0}', currentLang == 'en' ? courseDto.ProgramFullName : courseDto.ProgramFullNameFr)">
                </app-alert-banner>
              </div>
            }
            <div class="action-buttons-elig ontario-small-12 ontario-large-12 ontario-medium-12">
              <button class="link-button" (click)="resetEligibilityForm()">
                {{'TrainingEligibility.TryAgain' | translate}}
              </button>
              <button class="link-button" (click)="linkButtonClicked(learnMoreUrlPlaceholder)">
                {{'LoginHeader.LearnMore' | translate}}<img alt="external link" src="assets/images/external-link-blue.svg" [alt]="learnMoreUrlPlaceholder">
              </button>
            </div>
          </div>
        </div>
      }
      <!-- end Check Eligibility results -->
    }
    <!--end content -->
  </div>
</fieldset>
